export const savingCalculator = [
  {
    id: 1,
    title: "Balance Transfer Calculator",
    description:
      "Transferring debt to a credit card or loan with a lower interest rate can save you money on interest while you pay off your debt.",
  },
  {
    id: 2,
    inputsHeadingOne: "Details Current Loan After Balance Transfer",
    inputsHeadingTwo: "Details of New Loan",
  },
];

export const inputStyle = {
  backgroundColor: "#ffffff",
  border: "1.5px solid #b783cc",
  borderRadius: "5px",
  paddingTop: "0px",
  fontFamily: "'Archivo',sans-serif",
};

export const inputLabel = {
  fontFamily: "'Archivo', sans-serif",
  fontSize: "14px",
  fontWeight: 700,
  lineHeight: {
    sm: "18px",
    md: "20px",
    lg: "22px",
  },
};

export const outputLabel = {
  fontFamily: "'Archivo', sans-serif",
  fontSize: "13px",
  lineHeight: "24px",
  letterSpacing: "normal",
  textAlign: "start",
  fontWeight: 700,
};

export const outputStyle = {
  fontFamily: "'Archivo', sans-serif",
  fontSize: "24px",
  lineHeight: "24px",
  letterSpacing: "normal",
  textAlign: "start",
  fontWeight: 700,
  color: "#005FB9",
};
